import { Group, Mesh, MeshLambertMaterial, Scene, SphereGeometry } from 'three';
import { HALF_CITY, PALETTE, POPULATION } from '../../config/settings';
import { Updatable } from '../../core/types';
import { pick, randFloat } from '../../utils/random';

interface BalloonCluster {
  readonly group: Group;
  readonly baseY: number;
  readonly phase: number;
}

/** Clusters of balloons that gently bob and rotate above the streets. */
export class Balloons implements Updatable {
  private readonly clusters: BalloonCluster[] = [];
  private elapsed = 0;

  constructor(scene: Scene) {
    for (let i = 0; i < POPULATION.BALLOON_CLUSTERS; i++) {
      const cluster = this.createCluster();
      scene.add(cluster.group);
      this.clusters.push(cluster);
    }
  }

  update(dt: number): void {
    this.elapsed += dt;
    for (const c of this.clusters) {
      c.group.position.y = c.baseY + Math.sin(this.elapsed * 0.8 + c.phase) * 0.6;
      c.group.rotation.y = Math.sin(this.elapsed * 0.3 + c.phase) * 0.25;
    }
  }

  private createCluster(): BalloonCluster {
    const group = new Group();
    for (let i = 0; i < 5; i++) {
      const balloon = new Mesh(new SphereGeometry(0.8, 10, 10), new MeshLambertMaterial({ color: pick(PALETTE.balloons) }));
      balloon.position.set(randFloat(-1.2, 1.2), randFloat(0, 1.6), randFloat(-1.2, 1.2));
      balloon.scale.y = 1.25;
      group.add(balloon);
    }
    const baseY = randFloat(4, 8);
    group.position.set(randFloat(-HALF_CITY, HALF_CITY), baseY, randFloat(-HALF_CITY, HALF_CITY));
    return { group, baseY, phase: randFloat(0, 6) };
  }
}
